import firebase from 'firebase/compat/app';
import withoutNulls from '../api/search/withoutNulls';
import { FindAndReplace } from '../screens/DataManager/Metrics/MetricContextMenu/types';

export const FIND_AND_REPLACE_METRIC_RECEIPTS_COLLECTION =
  'findAndReplaceMetricReceipts';

const receiptConverter = {
  toFirestore(
    receipt: FindAndReplace.MetricReceipt,
  ): firebase.firestore.DocumentData {
    return withoutNulls({ ...receipt });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<FindAndReplace.MetricReceipt>,
    options: firebase.firestore.SnapshotOptions,
  ): FindAndReplace.MetricReceipt {
    return snapshot.data(options);
  },
};

const getFindAndReplaceReceiptsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(FIND_AND_REPLACE_METRIC_RECEIPTS_COLLECTION)
    .withConverter(receiptConverter);
};

export default getFindAndReplaceReceiptsRef;
